import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-30303552")

_pushScopeId("data-v-30303552")
const _hoisted_1 = { class: "top-banner" }
const _hoisted_2 = { class: "main-heading" }
const _hoisted_3 = /*#__PURE__*/_createVNode("label", { class: "heading-label" }, "&MEMBERSHIP", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")

  return (_openBlock(), _createBlock(_component_ion_header, null, {
    default: _withId(() => [
      _createVNode(_component_ion_toolbar, null, {
        default: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_ion_icon, {
                class: "membership-icon",
                icon: "/assets/icons/membership.svg"
              }),
              _hoisted_3
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})